import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[ospStepFooter]',
  standalone: true,
})
export class StepFooterDirective {
  constructor(public template: TemplateRef<unknown>) {
  }
}
